import styled from 'styled-components';

import { Typography } from 'src/app/components/Elements/Typography';

export const Image = styled.img`
  height: 8.4rem;
  margin: 0 auto;
`;

export const TextRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: ${props => props.theme.space['4.0']} ${props => props.theme.space.s5} ${props => props.theme.space.s5};
`;

export const TextTop = styled(Typography)`
  color: ${props => props.theme.colors.capsuleBlue50};
  font-family: ${props => props.theme.fonts.circular};
  font-weight: ${props => props.theme.fontWeights.roman};
  margin-bottom: ${props => props.theme.space.s2} !important;
`;

export const Text = styled(Typography)`
  color: ${props => props.theme.colors.capsuleBlue50};
  font-family: ${props => props.theme.fonts.circular};
  font-weight: ${props => props.theme.fontWeights.roman};
`;

export const HeaderTextRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${props => props.theme.space.s3} ${props => props.theme.space.s5};
  box-shadow: ${props => props.theme.shadows.dp2};
`;

export const HeaderText = styled(Typography)`
  color: ${props => props.theme.colors.capsuleGray50} !important;
  font-family: ${props => props.theme.fonts.circular};
  font-weight: ${props => props.theme.fontWeights.roman};
`;

export const ImageRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: ${props => props.theme.space['4.5']};
`;
